import type { SimpleChanges } from '@angular/core';
import { Component, Input } from '@angular/core';

import { TranslatePipe } from '@recruitee/i18n';
import { getSecondsInDays } from '@recruitee/time';
import { BadgeComponent, RtTooltip } from '@recruitee/user-interface';

@Component({
  selector: 'rt-overdue-candidate-badge',
  templateUrl: './overdue-candidate-badge.component.html',
  styleUrls: ['./overdue-candidate-badge.component.less'],
  imports: [BadgeComponent, RtTooltip, TranslatePipe],
  host: {
    '[class]': '[fontSize, borderRadius]',
  },
})
export class OverdueCandidateBadgeComponent {
  @Input('overdueDiff') public overdueSeconds: number;
  @Input() public hasTooltip: boolean;
  @Input() public tooltipHideDelay: number = 300;
  @Input() public fontSize: 'font-size-small-xx' | 'font-size-default' = 'font-size-small-xx';
  @Input() public borderRadius: 'border-radius' | 'border-radius-large' = 'border-radius';

  public overdueDays: number = 0;

  public ngOnChanges(changes: SimpleChanges): void {
    if (changes.overdueSeconds?.currentValue) {
      this.updateText();
    }
  }

  private updateText(overdueDiff = this.overdueSeconds): void {
    const overdue = Math.abs(overdueDiff);
    this.overdueDays = Math.ceil(getSecondsInDays(overdue));
  }
}
